import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { fetchStoreEventLogs } from "../../services/apiService";
import { useNavigate } from 'react-router';
import TablePagination from '../reused-components/TablePagination';
import {
    usePersistedPagination,
    useResetPageOnFilterChange,
} from '../../hooks/usePersistedPagination';

function StoreEventsLogTable({ type, paginationPerPage = 10, userId = null, siteId = null, storeId }) {
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const navigate = useNavigate();
    const storageKey = `store-events-${storeId || 'default'}-${type}-${userId || 'all'}-${siteId || 'all'}`;
    const {
        currentPage,
        perPage,
        setCurrentPage,
        setPerPage,
        resetToFirstPage,
        paginationDefaultPage,
    } = usePersistedPagination(storageKey, paginationPerPage);

    useResetPageOnFilterChange(resetToFirstPage, [type, userId, siteId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseData = await fetchStoreEventLogs(
                    storeId,
                    currentPage,
                    type,
                    userId,
                    siteId
                );
                setData(responseData.data || []);
                setTotalRows(responseData.total || 0);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [storeId, type, currentPage, userId, siteId]);

    const handleUserDetailClick = (userId) => {
        const handleUserDetailClick = (userId) => {
            // Todo
            // Redirect to User detail page only without product
        };
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        resetToFirstPage();
    };

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            cell: row => <span className="id-span">{row.id}</span>,
        },
        {
            name: 'Type',
            selector: row => row.type,
            sortable: true,
            cell: row => (
                <span className={`badge ${row.type === 'activate' ? 'green-badge' : 'orange-badge'}`}>
                    {row.type}
                </span>
            ),
        },
        {
            name: 'Created on',
            selector: row => row.created_at,
            sortable: true,
            cell: row => new Date(row.created_at).toLocaleString(),
        },
        {
            name: 'Install',
            selector: row => row.install,
            sortable: true,
        },
        {
            name: 'Trigger',
            selector: row => row.trigger,
            sortable: true,
            cell: row => <span onClick={() => handleUserDetailClick(row.trigger.split('-')[1].trim())}
                className="link-icon" >{row.trigger}</span>,
        },
        {
            name: 'Action',
            selector: row => row.action,
            sortable: true,
            cell: row => <a href="#">Retry all webhooks</a>,
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: true,
            cell: row => <span className="badge green-badge">processed</span>,
        },
    ];
    return (
        <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={perPage}
            paginationDefaultPage={paginationDefaultPage}
            paginationComponent={TablePagination}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            responsive
            className="custom-data-table"
        />
    );
}

export default StoreEventsLogTable;
